import Head from 'next/head'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

const SiteSEO = ({ faviconLink }) => {
  const { NODE_ENV } = publicRuntimeConfig
  return (
    <Head>
      {NODE_ENV === 'production' ? null : <meta name='robots' content='noindex,nofollow' />}
      <link href={faviconLink} rel='shortcut icon' />
      <script
        dangerouslySetInnerHTML={{
          __html: `
                window.dataLayer = window.dataLayer || []
                function gtag(){ dataLayer.push(arguments) }
            `,
        }}
      />
    </Head>
  )
}

export default SiteSEO
